import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { LogService } from '../services/log.service';
import { RouterService } from '../services/router.service';
import { LoginService } from '../services/login.service';
import { Challenge } from '../types/challenge';

@Injectable({
  providedIn: 'root'
})
export class LoginMfaSelfRegistrationGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private router: RouterService,
    private log: LogService
  ) {}

  canActivate() {
    const challenge = this.loginService.getChallenge();
    const isChallengeFound = challenge && challenge.isMfaSelfRegistration();

    if (!this.loginService.isInProgress() || !isChallengeFound) {
      this.log.trace(
        Challenge.MFA_SELF_REGISTRATION +
          ' challenge not found, routing to login',
        challenge
      );
      this.router.gotoLogin();
      return false;
    }

    this.log.trace('challenge found', challenge);

    return true;
  }
}
